import type { JSX } from 'react';

import { useDashboardPhase4Experiment } from '../../../../hooks/useDashboardPhase4Experiment';
import { Recommendations } from '../Recommendations';

import { Variant2 } from './variant2';

export function SharingTools({ viewContext }: { viewContext: 'home' }): JSX.Element {
	const {
		data: { variation },
	} = useDashboardPhase4Experiment();
	switch (variation) {
		case 'variant1':
			return <div>Variant 1</div>;
		case 'variant2':
			return <Variant2 />;
		default:
			return <Recommendations viewContext={viewContext} />;
	}
}
